var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9999 1.60001C3.57556 1.60001 3.16859 1.76858 2.86853 2.06864C2.56847 2.36869 2.3999 2.77566 2.3999 3.20001V14.4L5.1999 12.8L7.9999 14.4L10.7999 12.8L13.5999 14.4V3.20001C13.5999 2.77566 13.4313 2.36869 13.1313 2.06864C12.8312 1.76858 12.4242 1.60001 11.9999 1.60001H3.9999ZM7.7655 4.56561C7.91123 4.41472 7.99186 4.21264 7.99004 4.00289C7.98822 3.79313 7.90408 3.59248 7.75576 3.44415C7.60743 3.29582 7.40678 3.21169 7.19702 3.20987C6.98727 3.20804 6.78518 3.28868 6.6343 3.43441L4.2343 5.83441C4.08433 5.98443 4.00007 6.18787 4.00007 6.40001C4.00007 6.61214 4.08433 6.81558 4.2343 6.96561L6.6343 9.36561C6.78518 9.51133 6.98727 9.59197 7.19702 9.59015C7.40678 9.58832 7.60743 9.50419 7.75576 9.35586C7.90408 9.20753 7.98822 9.00688 7.99004 8.79713C7.99186 8.58737 7.91123 8.38529 7.7655 8.23441L6.7311 7.20001H7.9999C8.63642 7.20001 9.24687 7.45286 9.69696 7.90295C10.147 8.35304 10.3999 8.96349 10.3999 9.60001V10.4C10.3999 10.6122 10.4842 10.8157 10.6342 10.9657C10.7842 11.1157 10.9877 11.2 11.1999 11.2C11.4121 11.2 11.6156 11.1157 11.7656 10.9657C11.9156 10.8157 11.9999 10.6122 11.9999 10.4V9.60001C11.9999 8.53914 11.5785 7.52172 10.8283 6.77158C10.0782 6.02143 9.06077 5.60001 7.9999 5.60001H6.7311L7.7655 4.56561Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptRefund);
export default __webpack_public_path__ + "static/media/ReceiptRefund.5d802450e4d579c137778d29b71364fc.svg";
export { ForwardRef as ReactComponent };